import React, { useState } from 'react';
import { TextField, Button, Box, Paper } from '@mui/material';

const Filter = ({ onFilter }) => {
  const [idFilter, setIdFilter] = useState('');
  const [eventNameFilter, setEventNameFilter] = useState('');

  const handleIdChange = (event) => {
    setIdFilter(event.target.value);
  };

  const handleEventNameChange = (event) => {
    setEventNameFilter(event.target.value);
  };

  const handleFilterClick = () => {
    onFilter({ id: idFilter.trim(), eventName: eventNameFilter.trim() });
  };

  const handleClearClick = () => {
    setIdFilter('');
    setEventNameFilter('');
    onFilter({ id: '', eventName: '' });
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      onFilter({ id: idFilter.trim(), eventName: eventNameFilter.trim() });
    }
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: 2,
        mb: 2,
        transition: 'box-shadow 0.3s',
        '&:hover': {
          boxShadow: 6,
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <TextField
          label="Filter by ID"
          variant="outlined"
          size="small"
          value={idFilter}
          onChange={handleIdChange}
          onKeyPress={handleKeyPress}
          sx={{ flexGrow: 1, minWidth: 200 }}
        />
        <TextField
          label="Filter by Event Name"
          variant="outlined"
          size="small"
          value={eventNameFilter}
          onChange={handleEventNameChange}
          onKeyPress={handleKeyPress}
          sx={{ flexGrow: 1, minWidth: 200 }}
        />
        <Button variant="contained" color="primary" onClick={handleFilterClick}>
          Filter
        </Button>
        <Button variant="outlined" color="secondary" onClick={handleClearClick}>
          Clear
        </Button>
      </Box>
    </Paper>
  );
};

export default Filter;
